/**
 * 개요 막대(네비게이터) 설명 문구.
 *
 * 2026-09-03 (운영자 지적 → 실측 확인): 종전 문구 "밝은 영역이 위에서 보고
 * 있는 구간"은 **사실과 반대**였다. uPlot 의 선택 표시는 기본이 "검정 7%
 * 덮개"라 보고 있는 구간이 밝아지는 게 아니라 **어두워진다**.
 *
 *   확대 전/후 픽셀 실측 — 보고 있는 구간 바탕 255,255,255 → 237,237,237,
 *   그 구간의 보라 파형 196,181,253 → 182,168,235, 나머지 구간은 변화 없음.
 *   밝아진 세로줄 0개 · 어두워진 세로줄 123개(평균 밝기 −17.6).
 *
 * 게다가 확대하지 않은 상태에서는 음영 자체가 생기지 않으므로, 그 상태의
 * "밝은 영역"은 가리킬 대상조차 없는 말이었다. 그래서 문구를 **상태별로**
 * 나눈다.
 *
 * 확대 중 문구에는 조작 안내를 함께 넣는다 — 음영을 끌어 옮기고(pan) 양 끝을
 * 잡아 폭을 조절하는 기능은 이미 구현돼 있는데(TICPlotUplot 의 EDGE_PX 분기)
 * 화면 어디에도 쓰여 있지 않아, 커서 모양 변화를 우연히 발견한 사람만 쓸 수
 * 있었다. 화면에 쓰여 있지 않은 기능은 없는 기능이다.
 *
 * @param isZoomed 본 차트가 전 구간이 아닌 일부 구간을 보고 있는가.
 */
export function ticNavCaption(isZoomed: boolean): string {
  // 2026-09-06: 문구를 줄였다(운영자: "핵심만 간결하게"). 두 상태가 다르다는
  // 것과 조작 가능하다는 사실은 그대로 남긴다 — 화면에 쓰여 있지 않은 기능은
  // 없는 기능이다.
  return isZoomed
    ? "회색이 지금 보는 구간 · 끌면 옮기고 양 끝으로 폭 조절"
    : "드래그하면 그 구간만 확대";
}
